import { render, staticRenderFns } from "./Ranking.vue?vue&type=template&id=6951b834&scoped=true"
import script from "./Ranking.vue?vue&type=script&lang=ts"
export * from "./Ranking.vue?vue&type=script&lang=ts"
import style0 from "./Ranking.vue?vue&type=style&index=0&id=6951b834&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6951b834",
  null
  
)

export default component.exports